"use client";

import React from "react";
import { APIProvider } from "@vis.gl/react-google-maps";

import { mockLocationsIndexHeaderEN, mockLocationsIndexHeaderFR } from "@/mocks/locations";
import { CENTER_USA, TDict } from "../other/constants";
import { IBranch } from "@/app/[lang]/locations/helpers";
import LocationsIndexHeader from "./LocationsIndexHeader";
import LocationsIndex from "./LocationsIndex";
import { Locale } from "@/i18n.config";

const MainLocationsComponent = ({ dict, branches, lang }: { dict: TDict; branches: IBranch[]; lang: Locale }) => {
  const strings = lang === "fr" ? mockLocationsIndexHeaderFR : mockLocationsIndexHeaderEN;
  return (
    <>
      <LocationsIndexHeader {...strings} />
      <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API!}>
        <LocationsIndex dict={dict} branches={branches} center={CENTER_USA} zoom={4} />
      </APIProvider>
    </>
  );
};

export default MainLocationsComponent;
